module.exports = __webpack_public_path__ + "img/symbol_3.d9b37a8b.png";